<template>
    <div>
        <form>
            <div class="form-row">
                <div class="form-group col-md-6 row">
                    <label for="product" class="col-sm-3 col-form-label">Product</label>
                    <div class="col-sm-9">
                        <select class="form-control" v-model="product.product_id" @input="updateStatus">
                            <option selected disabled value="0">Choose...</option>
                            <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group col-md-6 row">
                    <label for="product" class="col-sm-3 col-form-label">Index</label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" v-model="product.index" @input="updateStatus">
                    </div>
                </div>
                <div class="form-group mr-auto ml-auto">
                    <button type="button" class="btn" @click="remove">&times;</button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import config from "../../../config";
    window.config = config;
    let setupData = (value) => {
        return {
            category_id: value.category_id,
            product_id: value.product_id,
            index: value.index
        };
    };
    let inProducts = (product, products) => {
        for (let index = 0; index < products.length; index++) {
            if (products[index].product_id === product.id) return true;
        }
        return false;
    };
    let fetchProducts = (product, _products) => {
        let { products, all_products } = _products;
        // products -> {category_id, product_id, index}
        // all_products -> {id, name, ...}
        // remain exist in products of this category, but not choosen by this
        products = products.filter(_product => !(_product.product_id === product.product_id));
        // remain all_products with hasn't been choose
        return all_products.filter(product => !inProducts(product, products));
    }
    export default {
        props: ["value", '_products'],
        watch: {
            value: {
                deep: true,
                handler(new_value, old_value) {
                    this.product = setupData(new_value);
                }
            },
            _products(new_value, old_value) {
                this.products = fetchProducts(this.product, new_value);
            }
        },
        data() {
            return {
                products: [],
                product: setupData(this.value)
            };
        },
        mounted() {
            this.products = fetchProducts(this.product, this._products);
        },
        methods: {
            updateStatus() {
                this.$emit('input', this.product);
            },
            remove() {
                this.$emit('remove');
            }
        }
    };
</script>
<style scoped></style>